<div class="dent-form">

  <!-- ── Affection + Praticien ── -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <label class="dent-label">Affection / Diagnostic</label>
      <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id" [(ngModel)]="itemToSave.affection_id"
        placeholder="Sélectionner l'affection" [searchable]="true">
      </ng-select>
    </div>
    <div class="col-6">
      <label class="dent-label">Praticien</label>
      <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id" [(ngModel)]="itemToSave.praticien_id"
        placeholder="Sélectionnez le praticien" [searchable]="true">
      </ng-select>
    </div>
  </div>

  <!-- ── Actes à réaliser ── -->
  <div class="mb-3">
    <label class="dent-label">Actes à réaliser</label>
    <div class="mb-2 d-flex align-items-center gap-2">
      <div class="flex-grow-1">
        <ng-select [items]="itemsActe" bindLabel="libelle" [(ngModel)]="selectedActeItem"
          placeholder="Sélectionner un acte" [searchable]="true" [loading]="loadingActes" [disabled]="loadingTarif"
          (change)="onAddItemToList()">
        </ng-select>
      </div>
      <div *ngIf="loadingTarif" class="d-flex align-items-center gap-1 text-primary"
        style="font-size:0.75rem;white-space:nowrap">
        <span class="spinner-border spinner-border-sm"></span> Chargement tarif...
      </div>
    </div>

    <div class="acte-list-wrap" style="overflow-x:auto">
      <table class="table table-sm mb-0"
        style="--bs-table-cell-padding-x:0.4rem;--bs-table-cell-padding-y:0.3rem;font-size:0.75rem">
        <thead class="custom-table-head">
          <tr>
            <th style="width:28px">#</th>
            <th>Acte</th>
            <th style="width:160px">Dent(s) / Diagnostic</th>
            <th style="width:30px"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itemsElement; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.acte_libelle }}</td>
            <td>
              <!-- Consultation : champ diagnostic -->

              <ng-container *ngIf="item.is_consultation">
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="item.diagnostic" [ngModelOptions]="{standalone:true}"
                  placeholder="Diagnostic *" [class.is-invalid]="!item.diagnostic?.trim()">
              </ng-container>
              <!-- Autres actes : bouton dents -->
              <ng-container *ngIf="!item.is_consultation">
                <button type="button" class="btn btn-sm btn-outline-secondary tooth-pick-btn"
                  (click)="openToothModal(item)">
                  <i class="fas fa-tooth me-1"></i>
                  <span *ngIf="countTeeth(item) === 0">Choisir</span>
                  <span *ngIf="countTeeth(item) > 0" class="badge bg-primary ms-1">{{ countTeeth(item) }}</span>
                </button>
              </ng-container>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-danger" (click)="itemsElement.splice(i, 1)">✕</button>
            </td>
          </tr>
          <tr *ngIf="!itemsElement.length">
            <td colspan="4" class="text-center text-muted py-2" style="font-size:0.75rem">
              <i class="fas fa-tooth me-1"></i>Aucun acte ajouté
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ── Modal sélection dents ── -->
  <div *ngIf="toothModalItem" class="tooth-modal-overlay" (click)="closeToothModal()">
    <div class="tooth-modal-box" (click)="$event.stopPropagation()">
      <div class="tooth-modal-header">
        <span><i class="fas fa-tooth me-1"></i>{{ toothModalItem.acte_libelle }}</span>
        <button (click)="closeToothModal()">&times;</button>
      </div>
      <div class="tooth-modal-body">
        <div class="tooth-chart-grid">
          <!-- Mâchoire supérieure -->
          <div class="tooth-row">
            <button *ngFor="let t of teethQ1" type="button" class="tooth-btn"
              [class.tooth-sel]="isToothSelectedForItem(toothModalItem, t)"
              (click)="toggleToothForItem(toothModalItem, t)">{{t}}</button>
            <span class="tooth-mid"></span>
            <button *ngFor="let t of teethQ2" type="button" class="tooth-btn"
              [class.tooth-sel]="isToothSelectedForItem(toothModalItem, t)"
              (click)="toggleToothForItem(toothModalItem, t)">{{t}}</button>
          </div>
          <!-- Mâchoire inférieure -->
          <div class="tooth-row">
            <button *ngFor="let t of teethQ4" type="button" class="tooth-btn"
              [class.tooth-sel]="isToothSelectedForItem(toothModalItem, t)"
              (click)="toggleToothForItem(toothModalItem, t)">{{t}}</button>
            <span class="tooth-mid"></span>
            <button *ngFor="let t of teethQ3" type="button" class="tooth-btn"
              [class.tooth-sel]="isToothSelectedForItem(toothModalItem, t)"
              (click)="toggleToothForItem(toothModalItem, t)">{{t}}</button>
          </div>
        </div>
        <div class="tooth-selected-summary" *ngIf="countTeeth(toothModalItem) > 0">
          <strong>{{ countTeeth(toothModalItem) }} dent(s) :</strong>
          {{ toothModalItem.dents_concernees }}
        </div>
      </div>
      <div class="tooth-modal-footer">
        <button class="btn btn-sm btn-outline-secondary" (click)="clearTeethForItem(toothModalItem)">
          <i class="fas fa-times me-1"></i>Effacer
        </button>
        <button class="btn btn-sm btn-primary" (click)="closeToothModal()">
          <i class="fas fa-check me-1"></i>Valider
        </button>
      </div>
    </div>
  </div>

  <!-- ── Footer ── -->
  <div class="dent-footer">
    <!-- <div class="legende-row">
      <span class="badge bg-success">Garanti</span>
      <span class="badge bg-warning text-dark">Entente préalable</span>
      <span class="badge bg-danger">Non garanti</span>
    </div> -->
    <button [disabled]="!itemsElement?.length" (click)="confirmSaveItem(itemToSave)"
      class="btn btn-success btn-sm px-4">
      <i class="fas fa-paper-plane me-1"></i>Enregistrer la prescription
    </button>
  </div>


</div><!-- /dent-form -->